export default {
  vi: {
    // AdminUsers
    aUsersTitle: 'Quản lý User',
    aUsersSubtitle: 'Quản lý thông tin người dùng',
    aUsersCreateAccount: 'Tạo tài khoản',
    aUsersStatTotal: 'Tổng người dùng',
    aUsersStatActive: 'Hoạt động',
    aUsersStatLocked: 'Bị khóa',
    aUsersStatNewToday: 'Mới hôm nay',
    aUsersSearchPlaceholder: 'Tìm kiếm theo tên, email, số điện thoại...',
    aUsersThUser: 'Người dùng',
    aUsersThBalance: 'Số dư',
    aUsersThOrders: 'Đơn hàng',
    aUsersThToday: 'Hôm nay',
    aUsersThReferrer: 'Người giới thiệu',
    aUsersThReferralCode: 'Mã giới thiệu',
    aUsersThStatus: 'Trạng thái',
    aUsersThJoined: 'Ngày tham gia',
    aUsersThActions: 'Hành động',
    aUsersLoading: 'Đang tải...',
    aUsersEmpty: 'Không tìm thấy user nào',
    aUsersStatusActive: 'Hoạt động',
    aUsersStatusLocked: 'Bị khóa',
    aUsersGenerateCodeConfirm: 'Xác nhận tạo mã giới thiệu cho user "{name}"?\n\nMã giới thiệu sẽ được tạo ngẫu nhiên và không thể thay đổi sau khi tạo.',
    aUsersGenerateCode: 'Tạo mã',
    aUsersView: 'Xem',
    aUsersShowing: 'Hiển thị {from} - {to} / {total} users',
    aUsersPrev: 'Trước',
    aUsersNext: 'Sau',
    aUsersCreateTitle: 'Tạo tài khoản mới',
    aUsersCreateSubtitle: 'Nhập thông tin user mới',
    aUsersLabelUsername: 'Tên đăng nhập',
    aUsersPlaceholderUsername: 'Nhập tên đăng nhập',
    aUsersLabelPhone: 'Số điện thoại',
    aUsersPlaceholderPhone: 'Nhập số điện thoại',
    aUsersLabelPassword: 'Mật khẩu',
    aUsersPlaceholderPassword: 'Nhập mật khẩu (tối thiểu 6 ký tự)',
    aUsersCancel: 'Hủy',
    aUsersCreating: 'Đang tạo...',
    // AdminUserDetail
    aUdLoading: 'Đang tải thông tin user...',
    aUdPromptNewPassword: 'Nhập mật khẩu mới (tối thiểu 6 ký tự):',
    aUdPasswordChanged: 'Đã đổi mật khẩu cho user.',
    aUdUnlockFrozenConfirm: 'Mở khóa {amount}? Toàn bộ tiền sẽ được chuyển vào số dư khả dụng.',
    aUdUnlockFrozenDone: 'Đã mở khóa {amount} vào số dư user.',
    aUdLockConfirm: 'Xác nhận khóa user này?',
    aUdUnlockConfirm: 'Xác nhận mở khóa user này?',
    aUdDeleteHistoryConfirm: '⚠️ XÓA TOÀN BỘ LỊCH SỬ QUAY ĐƠN?\n\nHành động này sẽ:\n- Xóa tất cả đơn hàng đã hoàn thành\n- Xóa tất cả đơn hàng đang chờ\n- Reset thống kê về 0\n\nKhông thể hoàn tác!',
    aUdDeleteHistoryDone: 'Đã xóa toàn bộ lịch sử quay đơn',
    aUdDeleteUserConfirm: '⚠️ XÓA USER VĨNH VIỄN?\n\nHành động này sẽ xóa:\n- Tài khoản user\n- Tất cả đơn hàng\n- Lịch sử nạp/rút\n- Ngân hàng & địa chỉ\n\nKHÔNG THỂ HOÀN TÁC!',
    aUdDeleteUserPrompt: 'Nhập "{keyword}" để xác nhận:',
    aUdCancelled: 'Hủy bỏ thao tác',
    aUdDeleteUserDone: 'Đã xóa user thành công',
    aUdReferrerSet: 'Đã set người giới thiệu thành công',
    aUdRemoveReferrerConfirm: 'Xóa người giới thiệu?',
    aUdReferrerRemoved: 'Đã xóa người giới thiệu',
    aUdCardBalance: 'Số dư',
    aUdCardFrozen: 'Số dư đóng băng',
    aUdCardCompleted: 'Đơn đã hoàn thành',
    aUdCardRemaining: 'Đơn còn lại',
    aUdCardTotalDeposit: 'Tổng đã nạp',
    aUdCardTotalWithdraw: 'Tổng đã rút',
    aUdBack: 'Quay lại danh sách user',
    aUdTitle: 'Chi tiết User',
    aUdSaveVip: 'Lưu VIP',
    aUdAddMoney: '+ Cộng tiền',
    aUdSubtractMoney: '− Trừ tiền',
    aUdChangePassword: 'Đổi mật khẩu',
    aUdChangePasswordShort: 'Đổi MK',
    aUdLockUser: 'Khóa user',
    aUdLockShort: 'Khóa',
    aUdUnlock: 'Mở khóa',
    aUdUnlockShort: 'Mở',
    aUdDeleteOrderHistoryBtn: 'Xóa lịch sử đơn',
    aUdDeleteHistoryShort: 'Xóa LS',
    aUdSetReferrer: 'Set người giới thiệu',
    aUdSetReferrerShort: 'Người GT',
    aUdGenerateReferralCode: 'Tạo mã giới thiệu',
    aUdGenerateCodeShort: 'Tạo mã',
    aUdDeleteUserBtn: 'Xóa user',
    aUdDeleteShort: 'Xóa',
    aUdReferrerLabel: 'Người giới thiệu:',
    aUdReferralCodeLabel: 'Mã giới thiệu:',
    aUdModalAddTitle: 'Cộng tiền cho user',
    aUdModalSubtractTitle: 'Trừ tiền của user',
    aUdCurrentBalance: 'Số dư hiện tại: {amount}',
    aUdAmountAdd: 'Số tiền cần cộng',
    aUdAmountSubtract: 'Số tiền cần trừ',
    aUdAmountPlaceholder: 'Ví dụ: 1000000',
    aUdCancel: 'Hủy',
    aUdProcessing: 'Đang xử lý...',
    aUdConfirmAdd: 'Xác nhận cộng tiền',
    aUdConfirmSubtract: 'Xác nhận trừ tiền',
    aUdLabelUsername: 'Tên người dùng',
    aUdPhone: 'SĐT: {value}',
    aUdNotUpdated: 'Chưa cập nhật',
    aUdLabelAccountLevel: 'Cấp tài khoản',
    aUdTotalOrders: 'Tổng đơn: {count}',
    aUdJoined: 'Tham gia: {value}',
    aUdLabelStatus: 'Trạng thái',
    aUdStatusActive: 'Hoạt động',
    aUdStatusLocked: 'Đã khóa',
    aUdDepositHistory: 'Lịch sử nạp: {count} giao dịch',
    aUdWithdrawHistory: 'Lịch sử rút: {count} giao dịch',
    aUdHistoryDeposits: 'Lịch sử nạp tiền',
    aUdEmptyDeposits: 'User chưa có lịch sử nạp tiền',
    aUdHistoryWithdraws: 'Lịch sử rút tiền',
    aUdEmptyWithdraws: 'User chưa có lịch sử rút tiền',
    aUdHistoryOrders: 'Lịch sử đơn hàng',
    aUdEmptyOrders: 'User chưa có lịch sử đơn hàng',
    aUdColAmount: 'Số tiền',
    aUdColMethod: 'Phương thức',
    aUdColTransactionCode: 'Mã giao dịch',
    aUdColStatus: 'Trạng thái',
    aUdColCreatedAt: 'Ngày tạo',
    aUdColBank: 'Ngân hàng',
    aUdColAccountName: 'Chủ tài khoản',
    aUdColOrderCode: 'Mã đơn',
    aUdColProduct: 'Sản phẩm',
    aUdColPrice: 'Giá',
    aUdColCommission: 'Hoa hồng',
    aUdReferrerModalSubtitle: 'Tìm kiếm user để làm người giới thiệu',
    aUdReferrerSearchPlaceholder: 'Tìm theo username, email, phone...',
    aUdReferrerNotFound: 'Không tìm thấy user nào',
    aUdReferrerTypeToSearch: 'Nhập để tìm kiếm...',
    aUdCodeModalSubtitle: 'Tạo mã giới thiệu ngẫu nhiên cho user này',
    aUdCodeModalBody: 'Mã giới thiệu sẽ được tạo ngẫu nhiên gồm 6 ký tự (chữ và số). User có thể dùng mã này để giới thiệu người khác.',
    aUdCreatingCode: 'Đang tạo...',
    // AdminVIP
    aVipTitle: 'Quản lý VIP',
    aVipSubtitle: 'Cấu hình các cấp độ VIP',
    aVipLoading: 'Đang tải cấu hình VIP...',
    aVipRequiredAmount: 'Số tiền yêu cầu',
    aVipCommissionPerOrder: 'Hoa hồng mỗi đơn',
    aVipOrderCount: 'Số lượng đơn hàng',
    aVipTaskLimit: 'Số nhiệm vụ mỗi ngày',
    aVipOrders: '{count} đơn',
    aVipCurrentUsers: 'Số người dùng hiện tại',
    aVipUsers: '{count} người',
    aVipConfigTitle: 'Cấu hình {name}',
    aVipCommissionPercent: 'Hoa hồng mỗi đơn (%)',
    aVipCancel: 'Hủy',
    aVipSaving: 'Đang lưu...',
    aVipSave: 'Lưu cấu hình',
    aVipNoticeLabel: 'Lưu ý:',
    aVipNoticeBody: 'Thay đổi cấu hình VIP sẽ ảnh hưởng đến tất cả người dùng. Hãy cân nhắc kỹ trước khi thay đổi.'
  },
  en: {
    // AdminUsers
    aUsersTitle: 'User Management',
    aUsersSubtitle: 'Manage user information',
    aUsersCreateAccount: 'Create account',
    aUsersStatTotal: 'Total users',
    aUsersStatActive: 'Active',
    aUsersStatLocked: 'Locked',
    aUsersStatNewToday: 'New today',
    aUsersSearchPlaceholder: 'Search by name, email, phone...',
    aUsersThUser: 'User',
    aUsersThBalance: 'Balance',
    aUsersThOrders: 'Orders',
    aUsersThToday: 'Today',
    aUsersThReferrer: 'Referrer',
    aUsersThReferralCode: 'Referral code',
    aUsersThStatus: 'Status',
    aUsersThJoined: 'Join date',
    aUsersThActions: 'Actions',
    aUsersLoading: 'Loading...',
    aUsersEmpty: 'No users found',
    aUsersStatusActive: 'Active',
    aUsersStatusLocked: 'Locked',
    aUsersGenerateCodeConfirm: 'Generate a referral code for user "{name}"?\n\nThe code will be generated randomly and cannot be changed after creation.',
    aUsersGenerateCode: 'Generate',
    aUsersView: 'View',
    aUsersShowing: 'Showing {from} - {to} of {total} users',
    aUsersPrev: 'Previous',
    aUsersNext: 'Next',
    aUsersCreateTitle: 'Create new account',
    aUsersCreateSubtitle: 'Enter new user information',
    aUsersLabelUsername: 'Username',
    aUsersPlaceholderUsername: 'Enter username',
    aUsersLabelPhone: 'Phone number',
    aUsersPlaceholderPhone: 'Enter phone number',
    aUsersLabelPassword: 'Password',
    aUsersPlaceholderPassword: 'Enter password (min. 6 characters)',
    aUsersCancel: 'Cancel',
    aUsersCreating: 'Creating...',
    // AdminUserDetail
    aUdLoading: 'Loading user information...',
    aUdPromptNewPassword: 'Enter new password (min. 6 characters):',
    aUdPasswordChanged: 'User password changed.',
    aUdUnlockFrozenConfirm: 'Unlock {amount}? The full amount will be moved to the available balance.',
    aUdUnlockFrozenDone: 'Unlocked {amount} to the user balance.',
    aUdLockConfirm: 'Lock this user?',
    aUdUnlockConfirm: 'Unlock this user?',
    aUdDeleteHistoryConfirm: '⚠️ DELETE ALL ORDER HISTORY?\n\nThis will:\n- Delete all completed orders\n- Delete all pending orders\n- Reset statistics to 0\n\nThis cannot be undone!',
    aUdDeleteHistoryDone: 'All order history deleted',
    aUdDeleteUserConfirm: '⚠️ PERMANENTLY DELETE USER?\n\nThis will delete:\n- The user account\n- All orders\n- Deposit/withdrawal history\n- Bank & address info\n\nThis CANNOT be undone!',
    aUdDeleteUserPrompt: 'Type "{keyword}" to confirm:',
    aUdCancelled: 'Operation cancelled',
    aUdDeleteUserDone: 'User deleted successfully',
    aUdReferrerSet: 'Referrer set successfully',
    aUdRemoveReferrerConfirm: 'Remove the referrer?',
    aUdReferrerRemoved: 'Referrer removed',
    aUdCardBalance: 'Balance',
    aUdCardFrozen: 'Frozen balance',
    aUdCardCompleted: 'Completed orders',
    aUdCardRemaining: 'Remaining orders',
    aUdCardTotalDeposit: 'Total deposited',
    aUdCardTotalWithdraw: 'Total withdrawn',
    aUdBack: 'Back to user list',
    aUdTitle: 'User details',
    aUdSaveVip: 'Save VIP',
    aUdAddMoney: '+ Add funds',
    aUdSubtractMoney: '− Deduct funds',
    aUdChangePassword: 'Change password',
    aUdChangePasswordShort: 'Password',
    aUdLockUser: 'Lock user',
    aUdLockShort: 'Lock',
    aUdUnlock: 'Unlock',
    aUdUnlockShort: 'Open',
    aUdDeleteOrderHistoryBtn: 'Delete order history',
    aUdDeleteHistoryShort: 'History',
    aUdSetReferrer: 'Set referrer',
    aUdSetReferrerShort: 'Referrer',
    aUdGenerateReferralCode: 'Generate referral code',
    aUdGenerateCodeShort: 'Generate',
    aUdDeleteUserBtn: 'Delete user',
    aUdDeleteShort: 'Delete',
    aUdReferrerLabel: 'Referrer:',
    aUdReferralCodeLabel: 'Referral code:',
    aUdModalAddTitle: 'Add funds to user',
    aUdModalSubtractTitle: 'Deduct funds from user',
    aUdCurrentBalance: 'Current balance: {amount}',
    aUdAmountAdd: 'Amount to add',
    aUdAmountSubtract: 'Amount to deduct',
    aUdAmountPlaceholder: 'e.g. 1000000',
    aUdCancel: 'Cancel',
    aUdProcessing: 'Processing...',
    aUdConfirmAdd: 'Confirm add funds',
    aUdConfirmSubtract: 'Confirm deduct funds',
    aUdLabelUsername: 'Username',
    aUdPhone: 'Phone: {value}',
    aUdNotUpdated: 'Not updated',
    aUdLabelAccountLevel: 'Account level',
    aUdTotalOrders: 'Total orders: {count}',
    aUdJoined: 'Joined: {value}',
    aUdLabelStatus: 'Status',
    aUdStatusActive: 'Active',
    aUdStatusLocked: 'Locked',
    aUdDepositHistory: 'Deposits: {count} transactions',
    aUdWithdrawHistory: 'Withdrawals: {count} transactions',
    aUdHistoryDeposits: 'Deposit history',
    aUdEmptyDeposits: 'No deposit history',
    aUdHistoryWithdraws: 'Withdrawal history',
    aUdEmptyWithdraws: 'No withdrawal history',
    aUdHistoryOrders: 'Order history',
    aUdEmptyOrders: 'No order history',
    aUdColAmount: 'Amount',
    aUdColMethod: 'Method',
    aUdColTransactionCode: 'Transaction code',
    aUdColStatus: 'Status',
    aUdColCreatedAt: 'Created at',
    aUdColBank: 'Bank',
    aUdColAccountName: 'Account holder',
    aUdColOrderCode: 'Order number',
    aUdColProduct: 'Product',
    aUdColPrice: 'Price',
    aUdColCommission: 'Commission',
    aUdReferrerModalSubtitle: 'Search for a user to set as referrer',
    aUdReferrerSearchPlaceholder: 'Search by username, email, phone...',
    aUdReferrerNotFound: 'No users found',
    aUdReferrerTypeToSearch: 'Type to search...',
    aUdCodeModalSubtitle: 'Generate a random referral code for this user',
    aUdCodeModalBody: 'The referral code will be randomly generated with 6 characters (letters and numbers). The user can use this code to refer others.',
    aUdCreatingCode: 'Generating...',
    // AdminVIP
    aVipTitle: 'VIP Management',
    aVipSubtitle: 'Configure VIP levels',
    aVipLoading: 'Loading VIP configuration...',
    aVipRequiredAmount: 'Required amount',
    aVipCommissionPerOrder: 'Commission per order',
    aVipOrderCount: 'Order count',
    aVipTaskLimit: 'Daily task allowance',
    aVipOrders: '{count} orders',
    aVipCurrentUsers: 'Current users',
    aVipUsers: '{count} users',
    aVipConfigTitle: 'Configure {name}',
    aVipCommissionPercent: 'Commission per order (%)',
    aVipCancel: 'Cancel',
    aVipSaving: 'Saving...',
    aVipSave: 'Save configuration',
    aVipNoticeLabel: 'Note:',
    aVipNoticeBody: 'Changes to VIP configuration affect all users. Please consider carefully before making changes.'
  },
  ko: {
    // AdminUsers
    aUsersTitle: '사용자 관리',
    aUsersSubtitle: '사용자 정보 관리',
    aUsersCreateAccount: '계정 생성',
    aUsersStatTotal: '총 사용자',
    aUsersStatActive: '활성',
    aUsersStatLocked: '잠김',
    aUsersStatNewToday: '오늘 신규',
    aUsersSearchPlaceholder: '이름, 이메일, 전화번호로 검색...',
    aUsersThUser: '사용자',
    aUsersThBalance: '잔액',
    aUsersThOrders: '주문',
    aUsersThToday: '오늘',
    aUsersThReferrer: '추천인',
    aUsersThReferralCode: '추천 코드',
    aUsersThStatus: '상태',
    aUsersThJoined: '가입일',
    aUsersThActions: '작업',
    aUsersLoading: '로딩 중...',
    aUsersEmpty: '사용자를 찾을 수 없습니다',
    aUsersStatusActive: '활성',
    aUsersStatusLocked: '잠김',
    aUsersGenerateCodeConfirm: '사용자 "{name}"의 추천 코드를 생성하시겠습니까?\n\n코드는 무작위로 생성되며 생성 후 변경할 수 없습니다.',
    aUsersGenerateCode: '코드 생성',
    aUsersView: '보기',
    aUsersShowing: '총 {total}명 중 {from} - {to} 표시',
    aUsersPrev: '이전',
    aUsersNext: '다음',
    aUsersCreateTitle: '새 계정 생성',
    aUsersCreateSubtitle: '새 사용자 정보 입력',
    aUsersLabelUsername: '아이디',
    aUsersPlaceholderUsername: '아이디 입력',
    aUsersLabelPhone: '전화번호',
    aUsersPlaceholderPhone: '전화번호 입력',
    aUsersLabelPassword: '비밀번호',
    aUsersPlaceholderPassword: '비밀번호 입력 (최소 6자)',
    aUsersCancel: '취소',
    aUsersCreating: '생성 중...',
    // AdminUserDetail
    aUdLoading: '사용자 정보 로딩 중...',
    aUdPromptNewPassword: '새 비밀번호 입력 (최소 6자):',
    aUdPasswordChanged: '사용자 비밀번호가 변경되었습니다.',
    aUdUnlockFrozenConfirm: '{amount}을(를) 해동하시겠습니까? 전액이 가용 잔액으로 이전됩니다.',
    aUdUnlockFrozenDone: '{amount}이(가) 사용자 잔액으로 해동되었습니다.',
    aUdLockConfirm: '이 사용자를 잠그시겠습니까?',
    aUdUnlockConfirm: '이 사용자를 잠금 해제하시겠습니까?',
    aUdDeleteHistoryConfirm: '⚠️ 모든 주문 기록을 삭제하시겠습니까?\n\n다음 작업이 실행됩니다:\n- 완료된 주문 전체 삭제\n- 대기 중인 주문 전체 삭제\n- 통계 초기화\n\n되돌릴 수 없습니다!',
    aUdDeleteHistoryDone: '모든 주문 기록이 삭제되었습니다',
    aUdDeleteUserConfirm: '⚠️ 사용자를 영구 삭제하시겠습니까?\n\n다음 항목이 삭제됩니다:\n- 사용자 계정\n- 모든 주문\n- 입금/출금 내역\n- 은행 및 주소 정보\n\n되돌릴 수 없습니다!',
    aUdDeleteUserPrompt: '"{keyword}"을(를) 입력하여 확인:',
    aUdCancelled: '작업이 취소되었습니다',
    aUdDeleteUserDone: '사용자가 삭제되었습니다',
    aUdReferrerSet: '추천인이 설정되었습니다',
    aUdRemoveReferrerConfirm: '추천인을 삭제하시겠습니까?',
    aUdReferrerRemoved: '추천인이 삭제되었습니다',
    aUdCardBalance: '잔액',
    aUdCardFrozen: '동결 잔액',
    aUdCardCompleted: '완료된 주문',
    aUdCardRemaining: '남은 주문',
    aUdCardTotalDeposit: '총 입금',
    aUdCardTotalWithdraw: '총 출금',
    aUdBack: '사용자 목록으로 돌아가기',
    aUdTitle: '사용자 상세',
    aUdSaveVip: 'VIP 저장',
    aUdAddMoney: '+ 금액 추가',
    aUdSubtractMoney: '− 금액 차감',
    aUdChangePassword: '비밀번호 변경',
    aUdChangePasswordShort: '비번',
    aUdLockUser: '사용자 잠금',
    aUdLockShort: '잠금',
    aUdUnlock: '잠금 해제',
    aUdUnlockShort: '해제',
    aUdDeleteOrderHistoryBtn: '주문 기록 삭제',
    aUdDeleteHistoryShort: '기록 삭제',
    aUdSetReferrer: '추천인 설정',
    aUdSetReferrerShort: '추천인',
    aUdGenerateReferralCode: '추천 코드 생성',
    aUdGenerateCodeShort: '코드 생성',
    aUdDeleteUserBtn: '사용자 삭제',
    aUdDeleteShort: '삭제',
    aUdReferrerLabel: '추천인:',
    aUdReferralCodeLabel: '추천 코드:',
    aUdModalAddTitle: '사용자에게 금액 추가',
    aUdModalSubtractTitle: '사용자 금액 차감',
    aUdCurrentBalance: '현재 잔액: {amount}',
    aUdAmountAdd: '추가 금액',
    aUdAmountSubtract: '차감 금액',
    aUdAmountPlaceholder: '예: 1000000',
    aUdCancel: '취소',
    aUdProcessing: '처리 중...',
    aUdConfirmAdd: '추가 확인',
    aUdConfirmSubtract: '차감 확인',
    aUdLabelUsername: '사용자명',
    aUdPhone: '전화: {value}',
    aUdNotUpdated: '미등록',
    aUdLabelAccountLevel: '계정 등급',
    aUdTotalOrders: '총 주문: {count}',
    aUdJoined: '가입일: {value}',
    aUdLabelStatus: '상태',
    aUdStatusActive: '활성',
    aUdStatusLocked: '잠김',
    aUdDepositHistory: '입금 내역: {count}건',
    aUdWithdrawHistory: '출금 내역: {count}건',
    aUdHistoryDeposits: '입금 내역',
    aUdEmptyDeposits: '입금 내역이 없습니다',
    aUdHistoryWithdraws: '출금 내역',
    aUdEmptyWithdraws: '출금 내역이 없습니다',
    aUdHistoryOrders: '주문 내역',
    aUdEmptyOrders: '주문 내역이 없습니다',
    aUdColAmount: '금액',
    aUdColMethod: '방법',
    aUdColTransactionCode: '거래번호',
    aUdColStatus: '상태',
    aUdColCreatedAt: '생성일',
    aUdColBank: '은행',
    aUdColAccountName: '예금주',
    aUdColOrderCode: '주문번호',
    aUdColProduct: '상품',
    aUdColPrice: '가격',
    aUdColCommission: '커미션',
    aUdReferrerModalSubtitle: '추천인으로 설정할 사용자 검색',
    aUdReferrerSearchPlaceholder: '아이디, 이메일, 전화번호로 검색...',
    aUdReferrerNotFound: '사용자를 찾을 수 없습니다',
    aUdReferrerTypeToSearch: '검색어를 입력하세요...',
    aUdCodeModalSubtitle: '이 사용자의 추천 코드를 무작위로 생성',
    aUdCodeModalBody: '추천 코드는 6자(문자·숫자)로 무작위 생성되며, 사용자는 이 코드로 다른 사용자를 추천할 수 있습니다.',
    aUdCreatingCode: '생성 중...',
    // AdminVIP
    aVipTitle: 'VIP 관리',
    aVipSubtitle: 'VIP 등급 설정',
    aVipLoading: 'VIP 설정 로딩 중...',
    aVipRequiredAmount: '요구 금액',
    aVipCommissionPerOrder: '주문당 커미션',
    aVipOrderCount: '주문 수량',
    aVipTaskLimit: '일일 임무 횟수',
    aVipOrders: '{count}건',
    aVipCurrentUsers: '현재 사용자 수',
    aVipUsers: '{count}명',
    aVipConfigTitle: '{name} 설정',
    aVipCommissionPercent: '주문당 커미션 (%)',
    aVipCancel: '취소',
    aVipSaving: '저장 중...',
    aVipSave: '설정 저장',
    aVipNoticeLabel: '참고:',
    aVipNoticeBody: 'VIP 설정 변경은 모든 사용자에게 영향을 줍니다. 변경 전 신중히 검토하세요.'
  },
  ja: {
    // AdminUsers
    aUsersTitle: 'ユーザー管理',
    aUsersSubtitle: 'ユーザー情報の管理',
    aUsersCreateAccount: 'アカウント作成',
    aUsersStatTotal: '総ユーザー数',
    aUsersStatActive: '有効',
    aUsersStatLocked: 'ロック',
    aUsersStatNewToday: '本日新規',
    aUsersSearchPlaceholder: '名前・メール・電話番号で検索...',
    aUsersThUser: 'ユーザー',
    aUsersThBalance: '残高',
    aUsersThOrders: '注文',
    aUsersThToday: '本日',
    aUsersThReferrer: '紹介者',
    aUsersThReferralCode: '紹介コード',
    aUsersThStatus: '状態',
    aUsersThJoined: '登録日',
    aUsersThActions: '操作',
    aUsersLoading: '読み込み中...',
    aUsersEmpty: 'ユーザーが見つかりません',
    aUsersStatusActive: '有効',
    aUsersStatusLocked: 'ロック済み',
    aUsersGenerateCodeConfirm: 'ユーザー「{name}」の紹介コードを作成しますか?\n\nコードはランダムに生成され、作成後は変更できません。',
    aUsersGenerateCode: 'コード作成',
    aUsersView: '表示',
    aUsersShowing: '全{total}件中 {from} - {to}を表示',
    aUsersPrev: '前へ',
    aUsersNext: '次へ',
    aUsersCreateTitle: '新規アカウント作成',
    aUsersCreateSubtitle: '新規ユーザー情報を入力',
    aUsersLabelUsername: 'ユーザー名',
    aUsersPlaceholderUsername: 'ユーザー名を入力',
    aUsersLabelPhone: '電話番号',
    aUsersPlaceholderPhone: '電話番号を入力',
    aUsersLabelPassword: 'パスワード',
    aUsersPlaceholderPassword: 'パスワードを入力(6文字以上)',
    aUsersCancel: 'キャンセル',
    aUsersCreating: '作成中...',
    // AdminUserDetail
    aUdLoading: 'ユーザー情報を読み込み中...',
    aUdPromptNewPassword: '新しいパスワードを入力(6文字以上):',
    aUdPasswordChanged: 'ユーザーのパスワードを変更しました。',
    aUdUnlockFrozenConfirm: '{amount}を解凍しますか? 全額が利用可能残高に移行します。',
    aUdUnlockFrozenDone: '{amount}を利用可能残高に解凍しました。',
    aUdLockConfirm: 'このユーザーをロックしますか?',
    aUdUnlockConfirm: 'このユーザーのロックを解除しますか?',
    aUdDeleteHistoryConfirm: '⚠️ 注文履歴をすべて削除しますか?\n\n実行内容:\n- 完了注文をすべて削除\n- 保留中の注文をすべて削除\n- 統計を0にリセット\n\n元に戻せません!',
    aUdDeleteHistoryDone: '注文履歴をすべて削除しました',
    aUdDeleteUserConfirm: '⚠️ ユーザーを完全削除しますか?\n\n削除対象:\n- ユーザーアカウント\n- すべての注文\n- 入金/出金履歴\n- 銀行・住所情報\n\n元に戻せません!',
    aUdDeleteUserPrompt: '「{keyword}」と入力して確認:',
    aUdCancelled: '操作をキャンセルしました',
    aUdDeleteUserDone: 'ユーザーを削除しました',
    aUdReferrerSet: '紹介者を設定しました',
    aUdRemoveReferrerConfirm: '紹介者を削除しますか?',
    aUdReferrerRemoved: '紹介者を削除しました',
    aUdCardBalance: '残高',
    aUdCardFrozen: '凍結残高',
    aUdCardCompleted: '完了注文',
    aUdCardRemaining: '残り注文',
    aUdCardTotalDeposit: '総入金',
    aUdCardTotalWithdraw: '総出金',
    aUdBack: 'ユーザー一覧に戻る',
    aUdTitle: 'ユーザー詳細',
    aUdSaveVip: 'VIP保存',
    aUdAddMoney: '+ 入金',
    aUdSubtractMoney: '− 出金',
    aUdChangePassword: 'パスワード変更',
    aUdChangePasswordShort: 'パス変更',
    aUdLockUser: 'ユーザーロック',
    aUdLockShort: 'ロック',
    aUdUnlock: 'ロック解除',
    aUdUnlockShort: '解除',
    aUdDeleteOrderHistoryBtn: '注文履歴削除',
    aUdDeleteHistoryShort: '履歴削除',
    aUdSetReferrer: '紹介者設定',
    aUdSetReferrerShort: '紹介者',
    aUdGenerateReferralCode: '紹介コード作成',
    aUdGenerateCodeShort: 'コード作成',
    aUdDeleteUserBtn: 'ユーザー削除',
    aUdDeleteShort: '削除',
    aUdReferrerLabel: '紹介者:',
    aUdReferralCodeLabel: '紹介コード:',
    aUdModalAddTitle: 'ユーザーに入金',
    aUdModalSubtractTitle: 'ユーザーから出金',
    aUdCurrentBalance: '現在残高: {amount}',
    aUdAmountAdd: '入金金額',
    aUdAmountSubtract: '出金金額',
    aUdAmountPlaceholder: '例: 1000000',
    aUdCancel: 'キャンセル',
    aUdProcessing: '処理中...',
    aUdConfirmAdd: '入金を確定',
    aUdConfirmSubtract: '出金を確定',
    aUdLabelUsername: 'ユーザー名',
    aUdPhone: '電話: {value}',
    aUdNotUpdated: '未登録',
    aUdLabelAccountLevel: 'アカウントランク',
    aUdTotalOrders: '総注文: {count}',
    aUdJoined: '登録日: {value}',
    aUdLabelStatus: '状態',
    aUdStatusActive: '有効',
    aUdStatusLocked: 'ロック済み',
    aUdDepositHistory: '入金履歴: {count}件',
    aUdWithdrawHistory: '出金履歴: {count}件',
    aUdHistoryDeposits: '入金履歴',
    aUdEmptyDeposits: '入金履歴がありません',
    aUdHistoryWithdraws: '出金履歴',
    aUdEmptyWithdraws: '出金履歴がありません',
    aUdHistoryOrders: '注文履歴',
    aUdEmptyOrders: '注文履歴がありません',
    aUdColAmount: '金額',
    aUdColMethod: '方法',
    aUdColTransactionCode: '取引番号',
    aUdColStatus: '状態',
    aUdColCreatedAt: '作成日',
    aUdColBank: '銀行',
    aUdColAccountName: '口座名義',
    aUdColOrderCode: '注文番号',
    aUdColProduct: '商品',
    aUdColPrice: '価格',
    aUdColCommission: 'コミッション',
    aUdReferrerModalSubtitle: '紹介者に設定するユーザーを検索',
    aUdReferrerSearchPlaceholder: 'ユーザー名・メール・電話番号で検索...',
    aUdReferrerNotFound: 'ユーザーが見つかりません',
    aUdReferrerTypeToSearch: '入力して検索...',
    aUdCodeModalSubtitle: 'このユーザーの紹介コードをランダム作成',
    aUdCodeModalBody: '紹介コードは6文字(英数字)でランダムに生成されます。ユーザーはこのコードを使って他の人を紹介できます。',
    aUdCreatingCode: '作成中...',
    // AdminVIP
    aVipTitle: 'VIP管理',
    aVipSubtitle: 'VIPランクの設定',
    aVipLoading: 'VIP設定を読み込み中...',
    aVipRequiredAmount: '必要金額',
    aVipCommissionPerOrder: '注文毎コミッション',
    aVipOrderCount: '注文数',
    aVipTaskLimit: '1日のタスク回数',
    aVipOrders: '{count}件',
    aVipCurrentUsers: '現在のユーザー数',
    aVipUsers: '{count}人',
    aVipConfigTitle: '{name}の設定',
    aVipCommissionPercent: '注文毎コミッション (%)',
    aVipCancel: 'キャンセル',
    aVipSaving: '保存中...',
    aVipSave: '設定を保存',
    aVipNoticeLabel: '注意:',
    aVipNoticeBody: 'VIP設定の変更はすべてのユーザーに影響します。変更前に慎重にご検討ください。'
  },
  zh: {
    // AdminUsers
    aUsersTitle: '用户管理',
    aUsersSubtitle: '用户信息管理',
    aUsersCreateAccount: '创建账户',
    aUsersStatTotal: '用户总数',
    aUsersStatActive: '活跃',
    aUsersStatLocked: '已锁定',
    aUsersStatNewToday: '今日新增',
    aUsersSearchPlaceholder: '按姓名、邮箱、手机号搜索...',
    aUsersThUser: '用户',
    aUsersThBalance: '余额',
    aUsersThOrders: '订单',
    aUsersThToday: '今日',
    aUsersThReferrer: '推荐人',
    aUsersThReferralCode: '推荐码',
    aUsersThStatus: '状态',
    aUsersThJoined: '注册时间',
    aUsersThActions: '操作',
    aUsersLoading: '加载中...',
    aUsersEmpty: '未找到用户',
    aUsersStatusActive: '活跃',
    aUsersStatusLocked: '已锁定',
    aUsersGenerateCodeConfirm: '确认为用户"{name}"生成推荐码?\n\n推荐码将随机生成,创建后不可更改。',
    aUsersGenerateCode: '生成码',
    aUsersView: '查看',
    aUsersShowing: '显示第 {from} - {to} 条,共 {total} 名用户',
    aUsersPrev: '上一页',
    aUsersNext: '下一页',
    aUsersCreateTitle: '创建新账户',
    aUsersCreateSubtitle: '填写新用户信息',
    aUsersLabelUsername: '用户名',
    aUsersPlaceholderUsername: '请输入用户名',
    aUsersLabelPhone: '手机号',
    aUsersPlaceholderPhone: '请输入手机号',
    aUsersLabelPassword: '密码',
    aUsersPlaceholderPassword: '请输入密码(至少 6 位)',
    aUsersCancel: '取消',
    aUsersCreating: '创建中...',
    // AdminUserDetail
    aUdLoading: '正在加载用户信息...',
    aUdPromptNewPassword: '请输入新密码(至少 6 位):',
    aUdPasswordChanged: '已修改用户密码。',
    aUdUnlockFrozenConfirm: '确认解冻 {amount}? 全部金额将转入可用余额。',
    aUdUnlockFrozenDone: '已解冻 {amount} 至用户余额。',
    aUdLockConfirm: '确认锁定该用户?',
    aUdUnlockConfirm: '确认解锁该用户?',
    aUdDeleteHistoryConfirm: '⚠️ 删除全部刷单历史?\n\n此操作将:\n- 删除所有已完成订单\n- 删除所有待处理订单\n- 统计归零\n\n不可撤销!',
    aUdDeleteHistoryDone: '已删除全部刷单历史',
    aUdDeleteUserConfirm: '⚠️ 永久删除用户?\n\n此操作将删除:\n- 用户账户\n- 全部订单\n- 充值/提现记录\n- 银行和地址信息\n\n不可撤销!',
    aUdDeleteUserPrompt: '输入"{keyword}"以确认:',
    aUdCancelled: '操作已取消',
    aUdDeleteUserDone: '用户删除成功',
    aUdReferrerSet: '推荐人设置成功',
    aUdRemoveReferrerConfirm: '删除推荐人?',
    aUdReferrerRemoved: '已删除推荐人',
    aUdCardBalance: '余额',
    aUdCardFrozen: '冻结余额',
    aUdCardCompleted: '已完成订单',
    aUdCardRemaining: '剩余订单',
    aUdCardTotalDeposit: '累计充值',
    aUdCardTotalWithdraw: '累计提现',
    aUdBack: '返回用户列表',
    aUdTitle: '用户详情',
    aUdSaveVip: '保存 VIP',
    aUdAddMoney: '+ 增加金额',
    aUdSubtractMoney: '− 扣减金额',
    aUdChangePassword: '修改密码',
    aUdChangePasswordShort: '改密',
    aUdLockUser: '锁定用户',
    aUdLockShort: '锁定',
    aUdUnlock: '解锁',
    aUdUnlockShort: '解锁',
    aUdDeleteOrderHistoryBtn: '删除订单历史',
    aUdDeleteHistoryShort: '删历史',
    aUdSetReferrer: '设置推荐人',
    aUdSetReferrerShort: '推荐人',
    aUdGenerateReferralCode: '生成推荐码',
    aUdGenerateCodeShort: '生成码',
    aUdDeleteUserBtn: '删除用户',
    aUdDeleteShort: '删除',
    aUdReferrerLabel: '推荐人:',
    aUdReferralCodeLabel: '推荐码:',
    aUdModalAddTitle: '为用户加款',
    aUdModalSubtractTitle: '从用户扣款',
    aUdCurrentBalance: '当前余额: {amount}',
    aUdAmountAdd: '加款金额',
    aUdAmountSubtract: '扣款金额',
    aUdAmountPlaceholder: '例如: 1000000',
    aUdCancel: '取消',
    aUdProcessing: '处理中...',
    aUdConfirmAdd: '确认加款',
    aUdConfirmSubtract: '确认扣款',
    aUdLabelUsername: '用户名',
    aUdPhone: '手机: {value}',
    aUdNotUpdated: '未填写',
    aUdLabelAccountLevel: '账户等级',
    aUdTotalOrders: '总订单: {count}',
    aUdJoined: '注册时间: {value}',
    aUdLabelStatus: '状态',
    aUdStatusActive: '正常',
    aUdStatusLocked: '已锁定',
    aUdDepositHistory: '充值记录: {count} 笔',
    aUdWithdrawHistory: '提现记录: {count} 笔',
    aUdHistoryDeposits: '充值记录',
    aUdEmptyDeposits: '该用户暂无充值记录',
    aUdHistoryWithdraws: '提现记录',
    aUdEmptyWithdraws: '该用户暂无提现记录',
    aUdHistoryOrders: '订单记录',
    aUdEmptyOrders: '该用户暂无订单记录',
    aUdColAmount: '金额',
    aUdColMethod: '方式',
    aUdColTransactionCode: '交易号',
    aUdColStatus: '状态',
    aUdColCreatedAt: '创建时间',
    aUdColBank: '银行',
    aUdColAccountName: '账户名',
    aUdColOrderCode: '订单号',
    aUdColProduct: '商品',
    aUdColPrice: '价格',
    aUdColCommission: '佣金',
    aUdReferrerModalSubtitle: '搜索用户设为推荐人',
    aUdReferrerSearchPlaceholder: '按用户名、邮箱、手机号搜索...',
    aUdReferrerNotFound: '未找到用户',
    aUdReferrerTypeToSearch: '输入关键词搜索...',
    aUdCodeModalSubtitle: '为该用户随机生成推荐码',
    aUdCodeModalBody: '推荐码将由 6 位字符(字母和数字)随机生成。用户可使用该推荐码邀请其他人。',
    aUdCreatingCode: '生成中...',
    // AdminVIP
    aVipTitle: 'VIP 管理',
    aVipSubtitle: '配置 VIP 等级',
    aVipLoading: '正在加载 VIP 配置...',
    aVipRequiredAmount: '要求金额',
    aVipCommissionPerOrder: '单笔佣金',
    aVipOrderCount: '订单数量',
    aVipTaskLimit: '每日任务次数',
    aVipOrders: '{count} 单',
    aVipCurrentUsers: '当前用户数',
    aVipUsers: '{count} 人',
    aVipConfigTitle: '配置 {name}',
    aVipCommissionPercent: '单笔佣金 (%)',
    aVipCancel: '取消',
    aVipSaving: '保存中...',
    aVipSave: '保存配置',
    aVipNoticeLabel: '注意:',
    aVipNoticeBody: '修改 VIP 配置将影响所有用户,请谨慎变更。'
  }
};
